/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Hero_TitleInputs */

const en_homepage_hero_title = /** @type {(inputs: Homepage_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen to academic papers on the go`)
};

const es_homepage_hero_title = /** @type {(inputs: Homepage_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escucha artículos académicos donde quieras`)
};

/**
* | output |
* | --- |
* | "Listen to academic papers on the go" |
*
* @param {Homepage_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_hero_title = /** @type {((inputs?: Homepage_Hero_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Hero_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_hero_title(inputs)
	return en_homepage_hero_title(inputs)
});